import type { ComponentCommonProps, Media, Theme } from '../../types/props.js'

/**
 * 响应式背景图片类型
 * 支持 5 个断点的图片配置
 */
export interface ResponsiveBackgroundImage {
  /** 默认图片 (<768px 移动端) */
  default?: Media
  /** tablet 断点图片 (≥768px) */
  tablet?: Media
  /** laptop 断点图片 (≥1025px) */
  laptop?: Media
  /** desktop 断点图片 (≥1440px) */
  desktop?: Media
  /** lg-desktop 断点图片 (≥1920px) */
  lgDesktop?: Media
}

export interface ActivityMechanismItem {
  /** 标题 */
  title: string
  /** 描述文本 */
  description: string
  /** 链接文本 */
  linkText?: string
  /** 链接地址 */
  linkHref?: string
  /** 响应式背景图片（支持 5 个断点） */
  backgroundImage?: ResponsiveBackgroundImage
}

/**
 * 语义化类名
 */
export type ActivityMechanismSemanticName = 'root' | 'grid' | 'card' | 'background' | 'title' | 'description' | 'link'

export interface ActivityMechanismProps extends ComponentCommonProps {
  data: {
    /** 活动机制列表 */
    items: ActivityMechanismItem[]
    /** 主题 */
    theme?: Theme
  }
  /** 语义化类名 */
  classNames?: Partial<Record<ActivityMechanismSemanticName, string>>
}
